module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAHlBMVEUAAAAeHh4XFxcZGRkYGBgZGRkaGhoZGRkaGhoZGRldKwsNAAAACnRSTlMAESIzVWZ3maq7rIOqKgAAAEZJREFUCB0FwaENgDAQAMArhNZ+gkGyArJb4LA4bAWpZwSYmDsByQG33CgnFx25lZPN1c1qTHt6jC9LUCM9GN8loH5gWPkBd80I5RQ5U/oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/d_arrow_b_w.png
// module id = 67
// module chunks = 0